export var createLoadSucceededEvent = function createLoadSucceededEvent(_ref, traceContext) {
  var fileId = _ref.fileId,
    fileMediatype = _ref.fileMediatype,
    fileMimetype = _ref.fileMimetype,
    fileSize = _ref.fileSize;
  return {
    eventType: 'operational',
    actionSubject: 'mediaFile',
    action: 'loadSucceeded',
    attributes: {
      status: 'success',
      fileMediatype: fileMediatype,
      fileMimetype: fileMimetype,
      fileAttributes: {
        fileId: fileId,
        fileMediatype: fileMediatype,
        fileMimetype: fileMimetype,
        fileSize: fileSize
      },
      traceContext: fileMediatype === 'image' ? traceContext : undefined
    }
  };
};